import { t } from '@/locales'

/**
 * What a create flow says about the welcome mail, so nobody has to remember the account's opt-in
 * (MIL-397) to know whether the user will be mailed. One place for the wording keeps the single
 * create, the CSV import and the order wizard from drifting apart.
 *
 * The two states are shown differently on purpose: a mail going out is the expected case and is
 * plain intro text; no mail going out is the one worth noticing and gets the yellow `warning`
 * `InfoText` — the app's format for "be aware of this".
 */
export function getWelcomeEmailIntroText({
  plural = false,
}: { plural?: boolean } = {}): string {
  return plural
    ? t('W: Hver oprettet bruger modtager en velkomstmail')
    : t('W: Brugeren modtager en velkomst-e-mail')
}

export function getNoWelcomeEmailWarningText(): string {
  return t(
    'W: Der sendes ingen velkomstmail — velkomstmails er ikke slået til for denne konto.'
  )
}
